<template>
  <div>
    <div class="header">
      <div class="title">{{title}}</div>
      <div class="right">
        <el-button type="danger" plain @click="close()">关闭</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      value: ''
    }
  },
  created() {
    console.log(this.title);
  },
  methods: {
    close() {
      this.$nw.close()
    },
  },
  mounted() {
    console.log(this.title)
  }
}
</script>
<style lang="less" scoped>
.header {
  width: 100%;
  height: 50px;
  text-align: center;
  background: #04b84f;
  position: relative;
  .title {
    width: 30%;
    margin: 0 auto;
    height: 50px;
    line-height: 50px;
    color: #ffffff;
    font-size: 24px;
    font-weight: 400;
  }
  .right {
    position: absolute;
    top: 5px;
    right: 10px;
  }
}
</style>